import { render, staticRenderFns } from "./InlineAddressFormGroup.vue?vue&type=template&id=134b8c7a&"
import script from "./InlineAddressFormGroup.vue?vue&type=script&lang=ts&"
export * from "./InlineAddressFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports